import { type RelayRefetchProp } from 'react-relay';
import { type RefetchFn } from '../types/layoutRefetch.ts';

import { type SbRespCreatorsLayoutRefetchQuery$variables } from '../SbRespCreatorsLayout/__generated__/SbRespCreatorsLayoutRefetchQuery.graphql.ts';
import { type SbMobileCreatorsLayoutRefetchQuery$variables } from '../SbMobileCreatorsLayout/__generated__/SbMobileCreatorsLayoutRefetchQuery.graphql.ts';

type RefetchVariables = Partial<
    (SbRespCreatorsLayoutRefetchQuery$variables | SbMobileCreatorsLayoutRefetchQuery$variables) & {
        afterDisplay: boolean;
    }
>;

export const handleUserRefetch = (
    relay: RelayRefetchProp,
    setIsClient: (isClient: boolean) => void
): RefetchFn<RefetchVariables> => {
    return (variables, renderVariables, callback) => {
        const isClient = variables?.afterDisplay === true;
        setIsClient(isClient);
        /**
         * Only set variables that are directly used by the `SbRespCreatorsLayoutRefetchQuery` and `
         * SbMobileCreatorsLayoutRefetchQuery`queries.
         * `followSearchTypes` is intentionally omitted so the refetch query default
         * (`[SEARCH, USER_PREFERENCE]`) applies. Passing it explicitly as `undefined` sends
         * `types: null`, which breaks the same favorites lookup.
         */
        const { userId, fetchUser, followSearchPages } = variables;
        relay.refetch(
            {
                userId,
                fetchUser,
                followSearchPages,
                isClient,
            },
            renderVariables,
            callback
        );
    };
};
